(function ready(fn) {
    // eslint-disable-next-line
    if (document.readyState != 'loading') {
        fn();
    } else {
        document.addEventListener('DOMContentLoaded', fn);
    }
}(() => {
    document.querySelector('.manage-cookie .action').addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (window.OneTrust !== undefined) {
            window.OneTrust.ToggleInfoDisplay();
        }
    });
}));
